import { render } from "./SingleCustomerChats.vue?vue&type=template&id=7ba68dd7&scoped=true"
import script from "./SingleCustomerChats.vue?vue&type=script&lang=js"
export * from "./SingleCustomerChats.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba68dd7"]])

export default __exports__